import type { flightEntity } from 'freedom-shared';

/**
 * Counts the total number of connections in an offer
 * A connection is when a flight has more than one segment
 */
export function countConnections(
  offer: flightEntity.types.MappedOffer,
): number {
  return offer.flights.reduce(
    (total, flight) => total + Math.max(0, flight.segments.length - 1),
    0,
  );
}

/**
 * Counts the total number of stops in an offer
 * A stop is when a segment has stops.count > 0
 */
export function countStops(offer: flightEntity.types.MappedOffer): number {
  return offer.flights.reduce(
    (total, flight) =>
      total +
      flight.segments.reduce((sum, segment) => sum + segment.stops.count, 0),
    0,
  );
}

/**
 * Checks if an offer is a direct flight (no connections and no stops)
 */
export function isDirectFlight(offer: flightEntity.types.MappedOffer): boolean {
  return countConnections(offer) === 0 && countStops(offer) === 0;
}
